import React from 'react';
import { Box, Container, Typography } from '@mui/material';

function Terms() {
  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 64px - 120px)',
        backgroundColor: '#F5F9FF',
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '2rem', md: '2.5rem' },
            fontWeight: 700,
            color: '#1A237E',
            mb: 3,
          }}
        >
          Användarvillkor
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 4 }}>
          Genom att använda Seglingssajten godkänner du följande villkor.
        </Typography>

        <Typography variant="h6" component="h2" sx={{ color: '#1A237E', fontWeight: 600, mb: 1.5, mt: 3 }}>
          Prenumerationsplaner
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2 }}>
          När du skapar ett konto får du automatiskt den kostnadsfria basplanen. Basplanen är gratis och ger tillgång till ett begränsat antal loggar: 10 tripploggar och 10 serviceloggar. Det räcker för att prova tjänsten och bygga upp en mindre loggbok. För obegränsat antal tripploggar och serviceloggar kan du uppgradera till Premium-planen för 39 kronor per månad. Det är användarens ansvar att vara medveten om vilken plan som är aktiv och vilka begränsningar som gäller.
        </Typography>

        <Typography variant="h6" component="h2" sx={{ color: '#1A237E', fontWeight: 600, mb: 1.5, mt: 3 }}>
          Uppsägning och nedgradering
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2 }}>
          Vid uppsägning av Premium-prenumerationen återgår kontot till den kostnadsfria basplanen vid nästa faktureringsdatum. Användaren är medveten om och accepterar att innehåll som överskrider gränserna för basplanen (mer än 10 tripploggar respektive 10 serviceloggar) kommer att tas bort 30 dagar efter att prenumerationen har återgått till basplanen. Genom att skapa PDF-filer av innehållet kan användaren ändå bevara innehållet från sitt konto.</Typography>

        <Typography variant="h6" component="h2" sx={{ color: '#1A237E', fontWeight: 600, mb: 1.5, mt: 3 }}>
          Användning av tjänsten
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2 }}>
          Användaren ansvarar för innehållet som laddas upp och garanterar att innehållet inte strider mot gällande lagar eller tredje parts rättigheter. Seglingssajten förbehåller sig rätten att ta bort innehåll som bryter mot dessa villkor.
        </Typography>

        <Typography variant="h6" component="h2" sx={{ color: '#1A237E', fontWeight: 600, mb: 1.5, mt: 3 }}>
          Ansvar
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2 }}>
          Seglingssajten ansvarar inte för förlust av data eller innehåll som kan uppstå vid tekniska problem eller vid borttagning av innehåll enligt dessa villkor.
        </Typography>

        <Typography variant="h6" component="h2" sx={{ color: '#1A237E', fontWeight: 600, mb: 1.5, mt: 3 }}>
          Ändringar av villkor
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121' }}>
          Seglingssajten förbehåller sig rätten att ändra dessa villkor. Användare kommer att informeras om väsentliga ändringar. Fortsatt användning av tjänsten efter ändringar innebär godkännande av de nya villkoren.
        </Typography>
      </Container>
    </Box>
  );
}

export default Terms;
